import { createContext, useContext } from 'react';

const SearchReadyContext = createContext(false);

export const useSearchReady = () => useContext(SearchReadyContext);

export const SearchReadyProvider = SearchReadyContext.Provider;
